<template>
  <div class="position-tips" :class="[direction]" :style="{ left: position.left, top: position.top }">
    <div class="position-content">
      <div class="tips-con">{{ text }}</div>
      <div class="position-tran"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: Object,
      default() {
        return {
          left: '20px',
          top: '200px',
        }
      },
    },
    text: {
      type: String,
      default: 'She has completed verification.',
    },
    direction: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.position-tips {
  position: fixed;
  width: fit-content;
  line-height: 14px;
  padding: 5px 12px;
  border-radius: 6px;
  background-color: #4e4e4e;
  .position-content {
    width: 100%;
    height: 100%;
    position: relative;
    .tips-con {
      min-width: 160px;
      max-width: 300px;
      font-family: 'Roboto-Regular';
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      line-height: 18px;
      word-break: break-word;
      white-space: normal;
    }
    .position-tran {
      position: absolute;
      bottom: -12px;
      z-index: -1;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 10px solid #4e4e4e;
    }
  }
}
.top {
  transform: translate(-50%, -100%);
  .position-tran {
    left: 50%;
    transform: translateX(-50%);
  }
}
.top-left {
  transform: translate(0, -100%);
  .position-tran {
    left: 0;
  }
}
.top-right {
  transform: translate(-100%, -100%);
  .position-tran {
    right: 0;
  }
}
</style>
